/* gk-personalizer */
if (!customElements.get('gk-personalizer')) {
  class GkPersonalizer extends HTMLElement {
    connectedCallback() {
      this.triggerOption = (this.dataset.triggerOption || '').trim().toLowerCase();
      this.triggerValue = (this.dataset.triggerValue || 'personalizar').trim().toLowerCase();

      // Tabs
      this.tabs = Array.from(this.querySelectorAll('[data-gkp-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-gkp-panel]'));
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.switchTab(tab.dataset.gkpTab)));

      // Player select
      this.playerSelect = this.querySelector('[data-gkp-player-select]');
      this.nameInput = this.querySelector('[data-gkp-name]');
      this.numberInput = this.querySelector('[data-gkp-number]');
      if (this.playerSelect) this.playerSelect.addEventListener('change', () => this.handlePlayerChange());

      // Font picker
      this.fontButtons = Array.from(this.querySelectorAll('[data-gkp-font]'));
      this.fontInput = this.querySelector('[data-gkp-font-input]');
      this.fontButtons.forEach((btn) => btn.addEventListener('click', () => this.selectFont(btn)));

      // Hidden type input
      this.typeInput = this.querySelector('[data-gkp-type]');

      // Bind handlers
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleFormData = this.handleFormData.bind(this);
      this.checkVisibility = this.checkVisibility.bind(this);

      // GLOBAL submit listener — antes do Dawn AJAX intercept
      document.addEventListener('submit', this.handleSubmit, true);
      // Backup: formdata event (dispara quando AJAX FormData é construído)
      document.addEventListener('formdata', this.handleFormData, true);
      // Visibility — escuta múltiplos eventos pra pegar qualquer interação com variant picker
      document.addEventListener('change', this.checkVisibility, true);
      document.addEventListener('click', this.checkVisibility, true);
      document.addEventListener('input', this.checkVisibility, true);

      // Roda várias vezes nos primeiros segundos pra garantir
      requestAnimationFrame(() => this.checkVisibility());
      setTimeout(() => this.checkVisibility(), 100);
      setTimeout(() => this.checkVisibility(), 500);
      setTimeout(() => this.checkVisibility(), 1500);
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.handleSubmit, true);
      document.removeEventListener('formdata', this.handleFormData, true);
      document.removeEventListener('change', this.checkVisibility, true);
      document.removeEventListener('click', this.checkVisibility, true);
      document.removeEventListener('input', this.checkVisibility, true);
    }

    isCartAddForm(form) {
      if (!(form instanceof HTMLFormElement)) return false;
      const action = form.getAttribute('action') || '';
      return action.indexOf('/cart/add') !== -1;
    }

    handleSubmit(e) {
      if (!this.isCartAddForm(e.target)) return;
      this.injectPropertiesIntoForm(e.target);
    }

    handleFormData(e) {
      if (!this.isCartAddForm(e.target)) return;
      if (this.hasAttribute('hidden')) return;
      const props = this.collectProperties();
      Object.keys(props).forEach((key) => {
        e.formData.set(key, props[key]);
      });
    }

    collectProperties() {
      const props = {};
      this.querySelectorAll('input[name^="properties["], select[name^="properties["]').forEach((input) => {
        const val = (input.value || '').toString();
        if (val.trim() === '') return;
        props[input.name] = val;
      });
      return props;
    }

    injectPropertiesIntoForm(form) {
      // Remove container anterior se existir
      let container = form.querySelector('[data-gkp-shadow]');
      if (container) container.remove();

      if (this.hasAttribute('hidden')) return; // não injeta se personalizer escondido

      container = document.createElement('div');
      container.setAttribute('data-gkp-shadow', '');
      container.style.display = 'none';
      form.appendChild(container);

      const props = this.collectProperties();
      Object.keys(props).forEach((name) => {
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = name;
        hidden.value = props[name];
        container.appendChild(hidden);
      });
    }

    checkVisibility() {
      const scope = this.closest('product-info') || this.closest('.product') || document;
      const selected = this.collectSelectedOptions(scope);

      let matched = false;
      selected.forEach((opt) => {
        const val = (opt.value || '').trim().toLowerCase();
        if (val === this.triggerValue) matched = true;
      });

      this.setVisible(matched);
    }

    collectSelectedOptions(scope) {
      const results = [];
      if (!scope || !scope.querySelectorAll) scope = document;

      // 1. Radios checked com name=options[...]
      scope.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
        if (input.name && input.name.startsWith('options[')) {
          results.push({ value: input.value });
        }
      });

      // 2. Selects com name=options[...]
      scope.querySelectorAll('select').forEach((sel) => {
        if (sel.name && sel.name.startsWith('options[')) {
          results.push({ value: sel.value });
        }
      });

      // 3. Dawn variant-radios fieldsets (caso radio não tenha name=options)
      scope.querySelectorAll('fieldset.product-form__input, variant-radios fieldset, .product-form__input').forEach((fs) => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (checked && checked.value) results.push({ value: checked.value });
      });

      // 4. Elements com aria-checked/pressed/selected = "true" (variant pills custom)
      scope.querySelectorAll('[aria-checked="true"], [aria-pressed="true"], [aria-selected="true"]').forEach((el) => {
        const val = el.getAttribute('data-value') || el.getAttribute('value') || el.dataset.optionValue || el.textContent.trim();
        if (val) results.push({ value: val });
      });

      // 5. Inputs hidden com name=options[...] (caso variante setada via JS)
      scope.querySelectorAll('input[type="hidden"][name^="options["]').forEach((input) => {
        if (input.value) results.push({ value: input.value });
      });

      return results;
    }

    setVisible(visible) {
      if (visible) this.removeAttribute('hidden');
      else this.setAttribute('hidden', '');
    }

    switchTab(name) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.gkpTab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        const active = panel.dataset.gkpPanel === name;
        if (active) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
      if (this.typeInput) {
        const activeTab = this.tabs.find((t) => t.dataset.gkpTab === name);
        if (activeTab) this.typeInput.value = activeTab.textContent.trim();
      }
    }

    handlePlayerChange() {
      const val = this.playerSelect.value || '';
      if (!val) return;
      const parts = val.split('|');
      const pName = (parts[0] || '').trim();
      const pNum = (parts[1] || '').trim();
      if (this.nameInput) this.nameInput.value = pName;
      if (this.numberInput) this.numberInput.value = pNum;
    }

    selectFont(btn) {
      this.fontButtons.forEach((b) => {
        const active = b === btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      if (this.fontInput) this.fontInput.value = btn.dataset.gkpFont;
    }
  }
  customElements.define('gk-personalizer', GkPersonalizer);
}
